import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from 'redux';
import { Button, Progress } from 'semantic-ui-react';
import { SimulationActions } from "../../../services/simulation/actions.jsx";
import { DataUtil } from '../../common/DataUtil.jsx';
import "../sidebar.scss";


class IntelligentSimulationsDisplay extends React.Component {

    state = {
        showCancelModal: false,
        simulationId: null
    }

    clickSimulation = (simulationId) => {
        if (this.props.simulationState.selectedSimulation != null) {
            // If currently selected simulation is clicked again - deselect it
            if (this.props.simulationState.selectedSimulation.id === simulationId) {
                this.props.selectSimulation(null);
                return;
            }
        }
        this.props.selectSimulation(simulationId);
    }

    getSimulationTable = (requiredStatuses, getLayout) => {
        var { t } = this.props;

        let sims = this.props.simulationState.simulations.filter(function (sim) {
            return requiredStatuses.includes(sim.status);
        });

        if (sims.length === 0) {
            return (
                <table className="table-display">
                    <tbody>
                        <tr><td><br/>{t("sidebar.noData")}<br/></td></tr>
                    </tbody>
                </table>
            )
        } else {
            return (
                <div className="table-display-div-intelligent">
                    <table className="table-display">
                        <tbody>
                            {this.makeSimTable(sims, getLayout)}
                        </tbody>
                    </table>
                </div>
            )
        }
    }

    makeSimTable = (filteredSims, getLayout) => {
        let simsDiv = [];
        for (let sim in filteredSims) {
            let simulation = filteredSims[sim] // eslint-disable-line security/detect-object-injection
            simsDiv.push(
                <tr
                    className={(this.props.simulationState.selectedSimulation &&
                        this.props.simulationState.selectedSimulation.id === simulation.id)
                        ? "active simulation-row"
                        : "simulation-row"}
                    key={simulation.status + simulation.id}
                    onClick={(e) => this.clickSimulation(simulation.id)}
                >
                    {getLayout(simulation)}
                </tr>
            )
        }
        return simsDiv
    }

    getFinishedSimsLayout = (simulation) => {
        return (
            <>
                <td key={simulation.id + "time"} className="simulation-timer">
                    {DataUtil.formatDate(new Date(simulation.lastUpdatedDate))}
                </td>
                <td key={simulation.id + "name"} className="simulation-name">{simulation.name}</td>
                <td key={simulation.id + "model"} className="simulation-model">{simulation.modelType}</td>
            </>
        )
    }

    render() {
        var { t } = this.props;

        return (
            <div >
                {this.getSimulationTable(["FINISHED","NOT_STARTED","RUNNING"], this.getFinishedSimsLayout)}
            </div>
        );
    }
}

const mapStateToProps = (store, props) => {
    return {
        simulationState: store.simulationState,
        scenarioState: store.scenarioState,
        ...props
    };
};

/*
* Maps properties to dispatch methods to send actions to the store reducers
*/
const mapDispatchToProps = (dispatch) => {
    return {
        selectSimulation: (simulationId) => {
            dispatch(SimulationActions.selectSimulation(simulationId));
        }
    }
}

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(IntelligentSimulationsDisplay);
